const DB_NAME = "mypos-manager";
const DB_VERSION = 1;
const STORE_KV = "kv";
const STORE_API_CACHE = "api-cache"; // reserved for Phase 5-B read-through cache

let dbP: Promise<IDBDatabase> | null = null;

function openDb(): Promise<IDBDatabase> {
  if (!dbP) {
    dbP = new Promise((resolve, reject) => {
      const req = indexedDB.open(DB_NAME, DB_VERSION);
      req.onupgradeneeded = () => {
        const db = req.result;
        if (!db.objectStoreNames.contains(STORE_KV)) db.createObjectStore(STORE_KV);
        if (!db.objectStoreNames.contains(STORE_API_CACHE)) db.createObjectStore(STORE_API_CACHE);
      };
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error);
    });
  }
  return dbP;
}

function tx<T>(
  store: string,
  mode: IDBTransactionMode,
  fn: (s: IDBObjectStore) => IDBRequest,
): Promise<T> {
  return openDb().then(
    (db) =>
      new Promise<T>((resolve, reject) => {
        const t = db.transaction(store, mode);
        const req = fn(t.objectStore(store));
        req.onsuccess = () => resolve(req.result as T);
        req.onerror = () => reject(req.error);
      }),
  );
}

export const idb = {
  get: <T = unknown>(key: string) => tx<T | undefined>(STORE_KV, "readonly", (s) => s.get(key)),
  set: (key: string, value: unknown) => tx<void>(STORE_KV, "readwrite", (s) => s.put(value, key)),
  remove: (key: string) => tx<void>(STORE_KV, "readwrite", (s) => s.delete(key)),
  clear: () => tx<void>(STORE_KV, "readwrite", (s) => s.clear()),
};
